<template>
  <div class="title-wrapper">
    <img src="@/assets/images/title_decoration_left.png" alt="装饰left">
    <div class="report-name">{{title}}</div>
    <img src="@/assets/images/title_decoration_right.png" alt="装饰right">
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '标题'
    }
  }
}
</script>


<style scoped lang="scss">
.title-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  img {
    height: 10px;
  }
  .report-name {
    padding: 0 6px;
    font-size: 18px;
    font-weight: 600;
    line-height: 23.87px;
    color: rgba(18, 18, 18, 1);
    text-align: center;
  }
}
</style>